<svg
  role="img"
  [ngClass]="classNames()"
  [attr.aria-hidden]="true"
  [attr.data-icon]="icon()"
  [attr.height]="iconDimensions[size()]"
  [attr.width]="iconDimensions[size()]"
>
  <use [attr.xlink:href]="iconUrl()"></use>
</svg>
